import Skeleton from "react-loading-skeleton";
import { useStore } from "../../hooks";
import { CouponCard, EmptyResult } from "..";
import { isEmpty } from "../../helpers";
import { StoreCouponModel } from "../../models";

const StoreCoupons = () => {

  const { isMenuLoading, storeCoupons } = useStore();

  if(isMenuLoading)
    return <Skeleton count={5} height={100} className="mb-3" />;

  if(!isMenuLoading && isEmpty(storeCoupons))
    return <EmptyResult message="No coupons found" />;

  return (
    <>
      <h3>Available Coupons</h3>
      <div className="offer_reward_sec">
        <ul>
          {storeCoupons.map((coupon: StoreCouponModel) => (
            <CouponCard coupon={coupon} key={coupon.id} />
          ))}
        </ul>
      </div>
    </>
  )
}

export default StoreCoupons;